import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'SOLICITACAO_COMPRA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'SOLICITACAO_COMPRA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('solicitacaoCompraForm', registro)
    ];
}

export function getLista(canceladas) {
	return (dispatch, getState) => {
	    axios.get(`${consts.API_URL}/solicitacaoCompra?apenas_abertas=true${canceladas ? '&canceladas=true' : ''}`).then(resp => {
			dispatch({
				type: 'SOLICITACAO_COMPRA_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/solicitacaoCompra`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				prazo: FormatUtils.formatarValorBanco(registro.prazo, 0),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(initForm({
					numero: resp.data.numero,
					formAberto: false
				}));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/solicitacaoCompra`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				prazo: FormatUtils.formatarValorBanco(registro.prazo, 0),
				datahora_cancelamento: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_cancelamento),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(initForm({
					numero: registro.numero,
					formAberto: false
				}));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/solicitacaoCompra?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(initForm({
				numero: registro.numero,
				formAberto: false
			}));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

//Histórico

export function initFormHistorico(registro = {}) {
    return [
        initialize('pedidoHistoricoForm', registro)
    ];
}

export function getListaHistoricos(numero) {
	return (dispatch, getState) => {
		dispatch({
			type: 'SOLICITACAO_HISTORICO_LISTADO',
			payload: {
				data: []
			}
		});

	    axios.get(`${consts.API_URL}/pedidoHistorico?numero_solicitacao=${numero || 0}`).then(resp => {
			dispatch({
				type: 'SOLICITACAO_HISTORICO_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarHistorico(registro) {
    return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/pedidoHistorico`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaHistoricos(registro.numero_solicitacao));
				dispatch(initFormHistorico(null));		
			}).catch(e => {
				setErroAPI(e);
			});					
		} else {
			axios.put(`${consts.API_URL}/pedidoHistorico`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaHistoricos(registro.numero_solicitacao));
				dispatch(initFormHistorico(null));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluirHistorico(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedidoHistorico?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaHistoricos(registro.numero_solicitacao));
			dispatch(initFormHistorico(null));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}